export default __webpack_public_path__ + "static/media/404.b5f3b249.png";